import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";
import { InputNumberComponent } from "./input-number.component";
import { NgxMaskModule } from "ngx-mask-2";

@NgModule({
  declarations: [
    InputNumberComponent
  ],
  imports: [
    CommonModule,
    FormsModule,
    NgxMaskModule.forRoot()
  ],
  providers: [

  ],
  exports: [
    InputNumberComponent
  ],
})
export class InputNumberModule {
  
}